import React, {Component, createRef} from 'react';
import './LeftButton.css';
import gsap from 'gsap';
import PropTypes from "prop-types";
import {getFM} from "../../Utilities/utils";

class LeftButton extends Component {

    constructor(props) {
        super(props);
        this.xbr = createRef();
        this.txt = createRef();
        this.anim = gsap.timeline({paused: true});
    }

    componentDidMount(){
        let txtWidth = (this.txt.current.offsetWidth + this.xbr.current.offsetWidth) *
            (this.txt.current.innerText.length<15 ? 1.2: 1.1);

        this.anim.to('#lb' + this.props.index, {
            width: txtWidth,
            backgroundColor: this.props.bgColor+'60',
            duration: 0.5
        }).to('#lbc' + this.props.index, {
            backgroundColor: 'transparent',
            duration: 0.3
        }, "0.2");
    }

    onMouseOver() {
        this.anim.play();
    }

    onMouseOut() {
        this.anim.reverse();
    }

    render() {
        return <div tabIndex={this.props.index}
            id={'lb' + this.props.index}
            className={"l-button accessibility-img " + this.props.className}
            style={{backgroundColor: this.props.bgColor+'25'}}>
            <a className={"l-button-content"}
               onMouseOver={() => this.onMouseOver()}
               onMouseOut={() => this.onMouseOut()}
               onClick={this.props.clickEvent} >
                <div id={'lbc' + this.props.index} ref={this.xbr}
                     className={"l-circle "}
                     style={{backgroundColor: this.props.circleColor }} >
                    <img className={"l-icon"} src={this.props.icon} alt="icon"/>
                </div>
                <span ref={this.txt}>
                    {getFM(this.props.label)}
                </span>
            </a>
        </div>
    }
}

LeftButton.propTypes = {
    index: PropTypes.number.isRequired,
    icon: PropTypes.string.isRequired,
    children: PropTypes.element,
    clickEvent: PropTypes.func.isRequired,
    bgColor: PropTypes.string,
    activeColor: PropTypes.string,
    circleColor: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.string,
}

LeftButton.defaultProps = {
    className: '',
    bgColor: '#624cbf',
    color: '#fff',
    circleColor: 'rgba( 250, 255, 255, 0.2)',
// 'radial-gradient(circle, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 90%, rgba(233,245,5,0.2) 100%)',
    width: '32vmin',
}

export default LeftButton;
